export default {
      id: "ach-usage",
      viewBox: "0 0 32 24",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#ach",
      toString: function () {
        return this.url;
      }
    }